export default __webpack_public_path__ + "static/media/headphone.4fc8710f.png";